<template>
    <nav class="navigation navigation--sub">
        <ul>
            <li v-for="item in items">
                <router-link :to="item.router" :title="item.key">{{ item.key }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        data() {
            return {
                items : this.getItems()
            }
        },
        methods : {
            getItems : function () {
                var items = [];

                if (this.$store.getters.userHasPermission('customer_view')) {
                    items.push({
                        key     : this.$t('customers.overview'),
                        router  : { name : 'customers-view-customer', params : { customer : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('location_list')) {
                    items.push({
                        key     : this.$t('locations'),
                        router  : { name : 'customers-view-customer-locations', params : { customer : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('project_list')) {
                    items.push( {
                        key     : this.$t('projects'),
                        router  : { name : 'customers-view-customer-projects', params : { customer : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('pm_list')) {
                    items.push({
                        key     : this.$t('pms'),
                        router  : { name : 'customers-view-customer-pms', params : { customer : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('admin_list')) {
                    items.push({
                        key     : this.$t('admins'),
                        router  : { name : 'customers-view-customer-admins', params : { customer : this.$route.params.customer } }
                    });
                }

                return items;
            }
        }
    }
</script>